import { InjectionToken, ModuleWithProviders, NgModule } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import type { IEnvironment } from "../models/interfaces/environment.interface";

export const ENVIRONMENT = new InjectionToken<IEnvironment>("ENVIRONMENT");

@NgModule({
  providers: [KeycloakService, provideHttpClient(withInterceptorsFromDi())],
})
export class KeycloakModule {
  static forRoot(environment: IEnvironment): ModuleWithProviders<KeycloakModule> {
    return {
      ngModule: KeycloakModule,
      providers: [{ provide: ENVIRONMENT, useValue: environment }],
    };
  }
}
